const createCookie = function() {

  function setCookie(name, value, days = 1) {
    let expires = "";

    if (days !== undefined) {
        if (days === Infinity) {
            // Configura o cookie para nunca expirar
            expires = "; expires=Fri, 31 Dec 9999 23:59:59 GMT";
        } else {
            // Calcula a data de expiração baseada nos dias fornecidos
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
    }

    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }
  
  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
  function deleteCookie(cname) {
    setCookie(cname, '', -1);
  }
  
  function checkCookie() {
    var user = getCookie("username");
    if (user != "") {
      alert("Welcome again " + user);
    } else {
      user = prompt("Please enter your name:", "");
      if (user != "" && user != null) {
        setCookie("username", user, 365);
      }
    }
  }

  function hasCookie(cname) {
    return !!getCookie(cname);
  }

  return {
    setCookie,
    getCookie,
    deleteCookie,
    checkCookie,
    hasCookie
  }
}

export default createCookie;
